module.exports = __webpack_public_path__ + "assets/40e8d94291c85c9b37f550c98a8c9d5b.mp3";